import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import TimPenilaiPSTahapanPage from 'app/KinerjaTimPenilaiPSPage/pages/Perencanaan/Tahapan'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardTimPenilai from 'app/KinerjaTimPenilaiPSPage/components/PageGuardTimPenilai'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ps-tim-penilai-ps-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page = (_props: PageProps) => (
  <PageGuardTimPenilai type="PPK">
    <TimPenilaiPSTahapanPage />
  </PageGuardTimPenilai>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Pengelolaan Kinerja',
}

export default Page
